module.exports = __webpack_public_path__ + "static/media/severity_high.c587b78f.svg";